import React from "react";
import { useNavigate } from "react-router-dom";

export default function Nep2ynPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-brandBlack text-brandWhite p-8">
      <button
        onClick={() => navigate("/")}
        className="mb-6 text-sm text-gray-400 underline"
      >
        ← Back to Home
      </button>

      <div className="flex flex-col items-center text-center space-y-6">
        {/* Logo */}
        <img
          src="/images/nep2ynlogo.jpg"
          alt="NEP2YN Logo"
          className="w-24 h-24"
        />

        {/* Portrait */}
        <img
          src="/images/nep2ynface.jpg"
          alt="NEP2YN Portrait"
          className="w-48 h-48 rounded-full object-cover border-4 border-gray-700"
        />

        {/* Title + Bio */}
        <h1 className="text-4xl font-bold mt-4">NEP2YN</h1>
        <p className="text-lg italic text-gray-400">CREATOR</p>
        <p className="max-w-xl text-sm text-gray-400">
          MY "POETRY" - MY FEELiNGS i FELT
          <br />
        </p>

        {/* 🦇 NOTES / BOOK ENTRY */}
        <div className="mt-10 w-full max-w-md flex flex-col space-y-4">
          <button
            onClick={() => navigate("/poetry/book-1")}
            className="border border-gray-700 hover:border-white transition-all duration-300 px-6 py-4 tracking-[0.2em] text-sm hover:bg-gray-900"
          >
            NOTE 1
          </button>

          <button
            onClick={() => navigate("/poetry/book-2")}
            className="border border-gray-700 hover:border-white transition-all duration-300 px-6 py-4 tracking-[0.2em] text-sm hover:bg-gray-900"
          >
            NOTE 2 (writing in progress...)
          </button>
        </div>
      </div>
    </div>
  );
}